<template>
  <div class="" id="trackPaginate">
    <vue-element-loading spinner="line-scale" color="#FF6700" :active.sync="isHandoverShipmentListLoader" text="Please Wait Loading Shipments..." />
    <table class="b-table table table-bordered pending-for-delivery-ShipmentList">
        <thead class="thead-default">
        <tr class="text-center">
          <th>Shipping ID</th>
          <th>Shipment Type</th>
          <th>Handover Date</th>
          <!-- <th>Status</th> -->
          <th>Assign Date</th>
          <th v-if="isRemoveOption"> &nbsp; </th>
        </tr>
        </thead>
        <tbody>
          <template v-if="HandoverShipmentList.length>0">
            <tr v-for="row in HandoverShipmentList" class="text-center">
              <td>{{row.shippingid}}</td>
              <td>{{row.shipmenttype}}</td>
              <td>{{row.handoverdate | moment }}</td>
              <!-- <td>{{row.status}} </td> -->
              <td>{{row.AssignDate | moment }}</td>
              <td v-if="isRemoveOption"><i @click="removeShipment(row.shippingid)" style="cursor: pointer;font-size:18px" class="fa fa-times-circle"></i></td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="6" align="center">No record found</td>
            </tr>
          </template>
        </tbody>
    </table>
    <paginate ref="paginate" :page-count="pageCount1" :page-range="2" :margin-pages="2" :click-handler="getPaginationData" :prev-text="'<<'" :next-text="'>>'" :container-class="'pagination'">
    </paginate>
  </div>
</template>


<script>
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'

export default {
  name: 'HanoverShipmentList',
  components: {
    VueElementLoading,
    Paginate
  },
  data: function() {
    return{

    }
  },
  props: {
    HandoverShipmentList: {
      type: Array,
      required: true,
    },
    isHandoverShipmentListLoader: {
      type: Boolean,
      required: true,
    },
    pageCount1: {
      type: Number
    },
    totalHandoverShipmentcnt: {
      type: Number
    },
    isRemoveOption: {
      type: Boolean
    }
  },
  methods: {
    getPaginationData(pageNum){
      this.$emit("getHandoverPaginationDataChild", pageNum);
      console.log('pageNum',pageNum);
    },
    removeShipment(shippingid){
      console.log('shippingid',shippingid);
      this.$emit("removeHandoverShipment", shippingid);
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
  }
}

</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/common/HanoverShipmentList.vue?ca6a2bec